<div class="modalka-add-to-favorites" [class.modal-favorites-show]="isBasketModalShow">
  <a class="close-modal" (click)="closeModal()"></a>
  <h4 class="text-center">{{ basketModalData.name }}</h4>
  <div class="hidden">
    <input type="text">
    <input type="text">
  </div>
  <div class="plus-minus-atf">
    <span class="minus" (click)="minusBasketCountGoodModal()"></span>
    <input type="number" class="count" [(ngModel)]="basketModalData.count">
    <span class="plus" (click)="plusBasketCountGoodModal()"></span>
  </div>
  <p class="text-center">Додайте товар у кошик</p>
  <button class="button modal button-basket" [disabled]="isSending" (click)="sendMobileBasket()">Додати у кошик</button>
</div>

<div class="dark-layer" [class.modal-favorites-show]="isDarkBackground" (click)="closeModal()"></div>
